import { ClerkProvider } from "@clerk/clerk-react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "@tanstack/react-router";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { resolveClerkPublishableKey } from "./clerk-env";
import "./index.css";
import { RootErrorBoundary } from "./RootErrorBoundary";
import { router } from "./router";

const clerkPk = resolveClerkPublishableKey();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

function App() {
  const inner = (
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  );
  if (!clerkPk) {
    return inner;
  }
  return <ClerkProvider publishableKey={clerkPk}>{inner}</ClerkProvider>;
}

const el = document.getElementById("root");
if (!el) {
  throw new Error("root element missing");
}

createRoot(el).render(
  <StrictMode>
    <RootErrorBoundary>
      <App />
    </RootErrorBoundary>
  </StrictMode>,
);
